import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const location = useLocation();
  const error = location.state?.error;

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/inbox";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center px-4" data-testid="login-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md rounded-3xl bg-white border border-brand-primary/10 p-10 shadow-[0_20px_60px_rgba(46,74,61,0.12)]"
      >
        <a href="/" data-testid="login-back-home" className="inline-flex items-center gap-2 text-sm text-brand-muted hover:text-brand-primary transition-colors">
          <ArrowLeft className="h-4 w-4" strokeWidth={1.5} /> Back to site
        </a>

        <img src="/logo.jpg" alt="NeuroNest" className="h-14 w-auto object-contain mt-8" />

        <h1 className="font-display font-light text-3xl text-brand-primary mt-6">
          Enquiry Inbox
        </h1>
        <p className="mt-3 text-brand-ink/70 leading-relaxed">
          Sign in with your NeuroNest Google account to view and manage appointment
          requests.
        </p>

        {error === "not_authorised" && (
          <p className="mt-5 rounded-lg bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700" data-testid="login-error">
            That account isn&apos;t authorised. Please sign in with the clinic&apos;s Google account.
          </p>
        )}

        <button
          onClick={handleLogin}
          data-testid="google-login-button"
          className="mt-8 w-full rounded-full bg-brand-primary text-brand-bg px-6 py-4 text-sm hover:bg-[#1f332a] transition-colors duration-300 flex items-center justify-center gap-3"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
            <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
            <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
            <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571.001-.001.002-.001.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
          </svg>
          Continue with Google
        </button>
      </motion.div>
    </div>
  );
}
